import React, { useEffect, useRef } from 'react';
var NumberScroll = function NumberScroll(_ref) {
  var count = _ref.count;
  var numberRef = useRef(null);
  var scrollNumber = function scrollNumber(digits) {
    var number = numberRef.current;
    if (number) {
      number.querySelectorAll('span[data-value]').forEach(function (element, index) {
        var numElement = element;
        numElement.style.transform = "translateY(-".concat(100 * parseInt(digits[index]), "%)");
      });
      number.style.width = "".concat(digits.length * 12, "px");
    }
  };
  var addDigit = function addDigit(digit) {
    var spanList = Array.from({
      length: 10
    }, function (_, j) {
      return "<span>".concat(j, "</span>");
    }).join('');
    var number = numberRef.current;
    if (number) {
      number.insertAdjacentHTML('beforeend', "<span style=\"transform: translateY(-1000%); ".concat(baseSpanStyle, "\" data-value=\"").concat(digit, "\">\n          ").concat(spanList, "\n        </span>"));
      var firstDigit = number.lastElementChild;
      firstDigit.className = 'visible';
      Object.assign(firstDigit.style, visibleSpanStyle);
    }
  };
  var setup = function setup(startNum) {
    var digits = startNum.toString().split('');
    digits.forEach(function () {
      return addDigit('0');
    });
    scrollNumber(['0']);
    setTimeout(function () {
      return scrollNumber(digits);
    }, 100);
  };
  var baseSpanStyle = "\n    display: flex;\n    text-align: center;\n    flex-direction: column;\n    opacity: 0;\n    flex-shrink: 2;\n    flex-basis: 48px;\n    width: 1px;\n    position: absolute;\n    right: 0;\n    line-height: 48px;\n    transition: all 1s ease;\n  ";
  var visibleSpanStyle = {
    position: 'static',
    width: '30px',
    opacity: 1,
    flexShrink: 1
  };
  useEffect(function () {
    setup(count);
  }, [count]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'Arial, sans-serif',
      color: 'rgba(75, 85, 99, 1)',
      fontWeight: 800,
      width: 'fit-content'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      alignItems: 'baseline',
      fontSize: '20px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: numberRef,
    id: "number",
    style: {
      position: 'relative',
      display: 'flex',
      overflow: 'hidden',
      height: '48px',
      transition: "width 0.3s ease"
    }
  })));
};
export default NumberScroll;